"use client";

import { Button } from "@mui/material";
import Image from "next/image";
import { useTranslations } from "next-intl";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import { getAssetUrl } from "@/utils/assetUrl";

const MYNIGHT_MASK_URL = "https://www.resmed.com/en-us/products/mynight-blackout-sleep-mask/";

export default function MyNightBanner() {
  const t = useTranslations("results-page.mynight-banner");

  return (
    <section className="mynight-banner">
      <div className="mynight-banner-content">
        <div className="mynight-banner-text-section">
          <h2 className="headline mynight-banner-headline">
            {t("headline")}
          </h2>
          <p className="mynight-banner-description">{t("description")}</p>
          <Button
            component="a"
            href={MYNIGHT_MASK_URL}
            target="_blank"
            rel="noopener noreferrer"
            variant="contained"
            disableElevation
            disableRipple
            className="mynight-banner-button"
            aria-label={t("button-aria-label")}
          >
            {t("button-text")}
            <OpenInNewIcon className="mynight-banner-button-icon" />
          </Button>
        </div>

        <div className="mynight-banner-image-section">
          <div className="mynight-banner-image-container">
            <Image
              src={getAssetUrl("/images/results/mynight_mobile.webp")}
              alt={t("image-alt")}
              className="mynight-banner-image"
              width={1097}
              height={768}
              unoptimized
            />
          </div>
        </div>
      </div>
    </section>
  );
}
